import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { LogService, Media } from 'htv-lib'

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  medias: Media[] = []
  isLoading$ = new BehaviorSubject<boolean>(true)

  constructor(private logService: LogService) {
    // do nothing
  }

  init(medias: Media[]) {
    this.logService.info(`MediaService - Saving Medias`)
    this.medias = medias
  }

  getMedia(id: string): Media | undefined {
    const index = this.medias.findIndex(media => media.id === id)
    if (index > -1) {
      return this.medias[index]
    } else {
      return undefined
    }
  }

  getMediaUrl(id: string): string | undefined {
    const media = this.getMedia(id)
    return media?.url
  }
}
